<template>
	<div class="list">
		<!--头部-->
		<XDheader></XDheader>
		<div class="container">
			<img src="https://scdn.xidong360.com/longhu-marathon/2019/0816/menu/banner.png" alt />
			<h5>当前位置/{{menuname?menuname:this.$route.params.key}}</h5>
			<div class="row" style="margin:0;">
				<div class="col-md-8">
				
					<div class="cc" v-if="message.length>0" v-html="message"></div>
					<!--列表-->
					<div class="listc">
							<div class="content_title" style="margin:0px 30px 30px 0;">
						<span class="themes_menu_wrap_1">{{menuname?menuname:this.$route.params.key}}</span>
					</div>
						<div
							v-for="newinfo in pagenews"
							:key="newinfo.uuid"
							class="newlist"
							@click="shownews(newinfo.uuid)"
						>
							<div class="left themes_news_title_1">
								<p class="dd">{{ new Date(newinfo.createtime) | moment("DD") }}</p>
								<p class="yy">{{ new Date(newinfo.createtime) | moment("YYYY-MM") }}</p>
							</div>
							<div class="right">
								<div
									style="display: -webkit-box;-webkit-box-orient: vertical; -webkit-line-clamp: 1;overflow: hidden;"
								>{{newinfo.title}}</div>
								<!-- <span class="el-icon-arrow-right"></span> -->
							</div>
						</div>
						<el-pagination
							style="text-align:center;margin-top:50px;"
							v-show="news.length>pagesize"
							background
							layout="prev, pager, next"
							:current-page="currentpage"
							:page-size="pagesize"
							:total="news.length"
							@current-change="changepage"
							@prev-click="prev"
							@next-click="next"
						></el-pagination>
					</div>
				</div>
				<div class="col-md-4">
					<XDright></XDright>
				</div>
			</div>
		</div>
		<!--底部-->
		<XDfooter></XDfooter>
	</div>
</template>
<script>
import api from "@/axios";
import { mapState, mapGetters } from "vuex";
import _ from "underscore";
export default {
	name: "List",
	data() {
		return {
			news: [],
			message: "",
			key: "",
			pagesize: 6,
			currentpage: 1,
			src: "",
			pagenews: []
		};
	},
	mounted() {
		this.getlist();
	},
	watch: {
		$route: "getlist"
	},
	methods: {
		getlist() {
			// console.log(this.$route.params);
			const { gameId, key } = this.$route.params;
			this.key = key;
			if (gameId) {
				api.getlist({ gameId, key }).then(({ data }) => {
					// console.log(data);
					if (data.code === 0 && data.data.length > 0) {
						this.news = data.data;
						this.getpagenews();
						this.message = "";
					} else {
						this.message = this.emptylist;
						this.news = [];
					}
				});
			}
		},
		getpagenews() {
			var currentpage = this.currentpage;
			var totalpage =
				this.news.length % this.pagesize == 0
					? this.news.length / this.pagesize
					: Math.floor(this.news.length / this.pagesize) + 1;
			var pagenews = [];
			for (
				var i = (currentpage - 1) * this.pagesize;
				i < this.news.length;
				i++
			) {
				pagenews.push(this.news[i]);
				if (pagenews.length == this.pagesize) break;
			}
			this.pagenews = pagenews;
		},
		preview(i) {
			this.src = i;
		},
		changepage(i) {
			if (i == this.currentpage) return;
			this.currentpage = i;
			this.getpagenews();
		},
		prev(i) {
			this.currentpage = i;
			this.getpagenews();
		},
		next(i) {
			this.currentpage = i;
			this.getpagenews();
		},
		shownews(uuid) {
			var newinfo = _.findWhere(this.news, { uuid });
			if (newinfo) {
				if (newinfo.from == 2) {
					window.open(newinfo.link, "_blank");
				} else {
					this.$router.push({
						path: "/" + this.gameId + "/content/" + uuid
					});
				}
			}
		}
	},
	computed: {
		...mapState(["gameId", "emptylist", "menuname"])
	}
};
</script>
<style scoped>
.list {
	height: 100vh;
	margin: 0;
	padding: 0;
	display: flex;
	flex-direction: column;
}
.container {
	flex-grow: 2;
}
.cc {
	height: 100%;
}
img {
	width: 100%;
}
.news_item {
	border-bottom: #ddd dashed 1px;
	padding-top: 5px;
	margin-bottom: 10px;
}
.listc {
	margin: 0px 0 20px;
	box-sizing: border-box;
}
/* 新闻列表 */
.newlist {
	display: flex;
	justify-content: flex-start;
	margin-right: 30px;
	background-color: #efefef;
	height: 80px;
	margin-bottom: 20px;
}
.newlist .left {
	width: 120px;
	text-align: center;
}
.newlist .right {
	width: 100%;
	padding: 0 30px;
	font-size: 20px;
	line-height: 80px;
	display: flex;
	justify-content: space-between;
}
.newlist .right span {
	line-height: 80px;
	font-size: 40px;
	color: #fefefe;
}
.dd,
.yy {
	margin-bottom: 0;
}
.dd {
	margin-bottom: 0;
	font-size: 35px;
}

/* 显示当前的目录 */
h5 {
	color: #999;
	margin-top: 20px;
	margin-bottom: 30px;
}
.col-md-8,
.col-md-4 {
	padding: 0;
}
img {
	width: 100%;
}
.container {
	padding: 0;
}

.content_title{
    text-indent:0;
    background-color: #EBEBEB;
    height: 60px;
    padding: 0;
    margin-bottom: 30px;
  }
  .content_title span{
    line-height: 60px;
    display: inline-block;
    height: 100%;
    box-shadow: none;
    padding: 0 30px;
  }
</style>



// WEBPACK FOOTER //
// src/template/pageList/list.vue